import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { FormControl, FormHelperText, Typography } from "@mui/material";
import RightToLeftLayout from "components/RightToLeft";
import { Controller } from "react-hook-form";

const EditorField = ({
  name,
  control,
  label,
  uploadPlugin = null,
  required = false,
  className = "",
  ...rest
}) => {
  return (
    <RightToLeftLayout>
      <FormControl fullWidth margin="normal" className={className}>
        {label && (
          <Typography variant="body2" fontWeight="bold" mb={1}>
            {label} {required && <span style={{ color: "red" }}>*</span>}
          </Typography>
        )}
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState: { error } }) => (
            <>
              <CKEditor
                editor={ClassicEditor}
                data={"as"}
                config={{
                  language: "fa",
                  toolbar: {
                    items: [
                      "heading",
                      "|",
                      "fontfamily",
                      "fontsize",
                      "|",
                      "bold",
                      "italic",
                      "underline",
                      "strikethrough",
                      "subscript",
                      "superscript",
                      "|",
                      "link",
                      "bulletedList",
                      "numberedList",
                      "todoList",
                      "|",
                      "outdent",
                      "indent",
                      "|",
                      "alignment",
                      "|",
                      uploadPlugin ? "imageUpload" : "",
                      "blockQuote",
                      "insertTable",
                      "mediaEmbed",
                      "undo",
                      "redo",
                      "code",
                      "codeBlock",
                      "highlight",
                      "fontColor",
                      "fontBackgroundColor",
                      "removeFormat",
                    ],
                    shouldNotGroupWhenFull: true,
                  },
                  table: {
                    contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
                  },
                  image: {
                    toolbar: ["imageTextAlternative", "imageStyle:full", "imageStyle:side"],
                  },
                  extraPlugins: uploadPlugin ? [uploadPlugin] : [],
                }}
                onChange={(event, editor) => {
                  let rawValue = editor.getData();
                  field.onChange(rawValue);
                }}
                onBlur={field.onBlur}
                {...rest}
              />
              {error && <FormHelperText error>{error.message}</FormHelperText>}
            </>
          )}
        />
      </FormControl>
    </RightToLeftLayout>
  );
};

export default EditorField;
